import MAYA from '../../../maya_api'
import _ from 'lodash'
import {setLoadingContent} from "../../../layouts/Content/modules/loadingContent";
import moment from "moment";

// ------------------------------------
// Constants
// ------------------------------------

const LOAD_TRANSACTIONS = 'LOAD_TRANSACTIONS';
const CHANGE_FILTER_DATES = 'CHANGE_FILTER_DATES';
const CANCEL_TRANSACTION = 'CANCEL_TRANSACTION';

function createInitialDatesFilter() {
  let startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
  let endDate = moment().format('YYYY-MM-DD');

  return {
    filter_start_date: startDate,
    filter_end_date: endDate
  }
}

const initialState = {
  list: [],
  ...createInitialDatesFilter()
};


// ------------------------------------
// Actions
// ------------------------------------


function loadTransactions() {
  return async (dispatch, getStore) => {
    dispatch(setLoadingContent(true));

    const startDate = getStore().transactions.filter_start_date;
    const endDate = getStore().transactions.filter_end_date;

    const list = await MAYA.getTransaction(startDate, endDate);

    dispatch(setLoadingContent(false));

    dispatch({
      type: LOAD_TRANSACTIONS,
      payload: list
    })
  }
}

function cancelTransaction(payment_guid) {
  return async (dispatch, getStore) => {

    const cancelResult = await MAYA.cancelTransaction(payment_guid);

    dispatch(loadTransactions());

    dispatch({
      type: CANCEL_TRANSACTION,
      action: cancelResult
    })
  }
}

function changeFilterDates(value = {}) {
  return {
    type: CHANGE_FILTER_DATES,
    payload: value
  }
}


export {
  cancelTransaction,
  loadTransactions,
  changeFilterDates
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [LOAD_TRANSACTIONS]: (state, action) => ({
    ...state,
    list: action.payload
  }),
  [CHANGE_FILTER_DATES]: (state, action) => ({
    ...state,
    filter_start_date: action.payload.startDate,
    filter_end_date: action.payload.endDate
  }),
  [CANCEL_TRANSACTION]: (state, action) => state
};

// ------------------------------------
// Reducer
// ------------------------------------

export default function transactionsReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/components/Transactions/modules/transactions.js